import React, { memo } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { StarIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const BrandsShowcase = memo(function BrandsShowcase() {
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Advanced Night Repair Serum',
    brand: 'Estée Lauder',
    price: 89.99,
    originalPrice: 129.99,
    discount: 31,
    rating: 4.9,
    reviewCount: 3456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Revitalift Triple Power',
    brand: "L'Oréal Paris",
    price: 34.99,
    originalPrice: 49.99,
    discount: 30,
    rating: 4.7,
    reviewCount: 2103,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Moisture Surge 72H',
    brand: 'Clinique',
    price: 54.99,
    originalPrice: 74.99,
    discount: 27,
    rating: 4.8,
    reviewCount: 1789,
    image: PRODUCT_IMAGES[2],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Hydro Boost Water Gel',
    brand: 'Neutrogena',
    price: 24.99,
    originalPrice: 34.99,
    discount: 29,
    rating: 4.6,
    reviewCount: 1234,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Crème de la Mer',
    brand: 'La Mer',
    price: 189.99,
    originalPrice: 249.99,
    discount: 24,
    rating: 4.9,
    reviewCount: 987,
    image: PRODUCT_IMAGES[4],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Youth To The People Cleanser',
    brand: 'Youth To The People',
    price: 44.99,
    originalPrice: 59.99,
    discount: 25,
    rating: 4.8,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="w-full" data-id="element-2175" data-mp="ciumgjk5ivw5">
      <div className="container mx-auto px-4" data-id="element-2176" data-mp="ci1oo8367gq5">
        <div className="bg-gradient-to-r from-amber-600 to-orange-600 rounded-xl overflow-hidden mb-6" data-id="element-2177" data-mp="ckxmlwf0q5el">
          <div className="p-6 md:p-8" data-id="element-2178" data-mp="hfthd4bn36ve">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2179" data-mp="lk126qez82oc">
              <div className="mb-4 md:mb-0" data-id="element-2180" data-mp="2ja2fj4eiff9k">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2181" data-mp="2jb3uvl2k6nx3">
                  PREMIUM BRANDS
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2182" data-mp="2fso7ugrujvyt">
                  <StarIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2183" data-mp="2azbuj2smbbld" />
                  Top Brands
                </h2>
              </div>
              <a href="#" className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center" data-id="element-2184" data-mp="21zyfzvpmzwts">
                View All
                <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2185" data-mp="2tsfpqslhhwi3" />
              </a>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative" data-id="element-2186" data-mp="2kr97adz9ybm7">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2187" data-mp="2kpy7ep8y9o0d">
              {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
            width: 'calc(50% - 6px)'
          }} data-id="element-2188" data-mp="320sb3051ejm2">
                  <EnhancedProductCard product={product} data-id="element-2189" data-mp="3fyqa8yase9gz" />
                </div>)}
            </div>
            {/* Pagination Dots */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-2190" data-mp="3kx1k39130jz7">
              {Array.from({
            length: totalSlides
          }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-2191" data-mp="3bwdf13to1tyg" data-mpi={index} />)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2192" data-mp="1nzvvuux57b51">
            {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-2193" data-mp="21ydggjrr47iq" />)}
          </div>}
      </div>
    </div>;
});